
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M17.01 14H16.21L15.94 13.73C17.09 12.39 17.7 10.59 17.45 8.64003C17.11 6.00003 15.1 3.78003 12.5 3.18003C8.26001 2.20003 4.51001 5.53003 4.51001 9.50003H2.41001C1.94001 9.50003 1.73001 10.09 2.10001 10.39L5.50001 13.14C5.69001 13.34 6.01001 13.35 6.21001 13.15L9.11001 10.36C9.43001 10.05 9.21001 9.50003 8.76001 9.50003H6.51001C6.51001 7.01003 8.51001 5.02003 10.97 5.00003C13.41 4.98003 15.51 7.05003 15.51 9.49003C15.51 11.97 13.49 14 11.01 14C10.56 14 10.12 13.93 9.71001 13.81C9.37001 13.71 9.00001 13.81 8.75001 14.07C8.22001 14.6 8.43001 15.52 9.14001 15.73C9.73001 15.9 10.36 16 11.01 16C12.62 16 14.09 15.41 15.23 14.43L15.5 14.7V15.49L19.77 19.74C20.18 20.15 20.84 20.15 21.25 19.74C21.66 19.33 21.66 18.66 21.25 18.25L17.01 14Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-youtube-searched-for`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconYoutubeSearchedFor

    ```js
    <b-new-b-icon-youtube-searched-for />
    ```
</docs>


